import styled from 'styled-components';

export const PrinterSettingStyled = styled.div`
  max-width: 600px;
  padding: 30px 20px 0px 80px;
  flex: 1;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 500px;
    padding: 0px;
    margin: 0 auto;
  }
`;
